/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Write_ConflictInputs */

const en_us2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan kept changing while we saved it. Refresh and try again.`)
};

const pt_br2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano mudou várias vezes enquanto salvávamos. Atualize a tela e tente de novo.`)
};

const es_419_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan siguió cambiando mientras lo guardábamos. Actualiza e inténtalo de nuevo.`)
};

const pt_pt2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano mudou várias vezes enquanto o guardávamos. Atualiza o ecrã e tenta de novo.`)
};

const fr_fr2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme a changé plusieurs fois pendant l'enregistrement. Actualise et réessaie.`)
};

const de_de2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan hat sich beim Speichern ständig geändert. Aktualisiere und versuch es erneut.`)
};

const it_it2_plan_write_conflict = /** @type {(inputs: Plan_Write_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda ha continuato a cambiare mentre la salvavamo. Aggiorna e riprova.`)
};

/**
* | output |
* | --- |
* | "The plan kept changing while we saved it. Refresh and try again." |
*
* @param {Plan_Write_ConflictInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_write_conflict = /** @type {((inputs?: Plan_Write_ConflictInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Write_ConflictInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_write_conflict(inputs)
	if (locale === "es-419") return es_419_plan_write_conflict(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_write_conflict(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_write_conflict(inputs)
	if (locale === "de-DE") return de_de2_plan_write_conflict(inputs)
	if (locale === "it-IT") return it_it2_plan_write_conflict(inputs)
	return en_us2_plan_write_conflict(inputs)
});
export { plan_write_conflict as "plan.write_conflict" }